
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_tenants/temporary-unavailable",
      function () {
        return require("private-next-pages/_tenants/temporary-unavailable.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_tenants/temporary-unavailable"])
      });
    }
  